$(document).ready(function() {
    /* Favorites */
    $('.favorite').on('click', function(e) {
        var favorID = $(this).attr('data-item');
        if($(this).hasClass('active'))
            var doAction = 'delete';
        else
            var doAction = 'add';
        addFavorite(favorID, doAction);
    });
    /* Favorites */

    $('.catalog-item__favorite-remove').click(function() {
		window.setTimeout('location.reload()', 500);
	});


/* Избранное */
    function addFavorite(id, action)
    {   
        var param = 'id='+id+"&action="+action;
        $.ajax({
            url:     '/local/ajax/favorites.php', // URL отправки запроса
            type:     "GET",
            dataType: "html",
            data: param,
            success: function(response) { // Если Данные отправлены успешно
                var result = $.parseJSON(response);
                if(result == 1){ // Если всё чётко, то выполняем действия, которые показывают, что данные отправлены
                    $('.favorite[data-item="'+id+'"]').addClass('favorite--active');
                    $('.favorite--active span').text('В избранном');
                    var wishCount = parseInt($('.favorites-counter').html()) + 1;
                    $('.favorites-counter').html(wishCount); // Визуально меняем количество у иконки
                }
                if(result == 2){
                    $('.favorite[data-item="'+id+'"]').removeClass('favorite--active');
                    $('.favorite span').text('Добавить в избранное');
                    var wishCount = parseInt($('.favorites-counter').html()) - 1;
                    $('.favorites-counter').html(wishCount); // Визуально меняем количество у иконки
                }
            },
            error: function(jqXHR, textStatus, errorThrown){ // Ошибка
                console.log('Error: '+ errorThrown);
            }
         });
    }
/* Избранное */
});